module.exports = __webpack_public_path__ + "static/media/3-kingdoms-battle-of-red-cliffs.baabb473.gif";